import React, { useEffect } from "react";
import TopBanner from "../components/TopBanner";
import { ContentWrapper } from "./InsuranceGuidance";
import { Text } from "./Disclaimer";

const RefundPolicy = () => {
  useEffect(() => {
    document.title = "Refund Policy – Wealthies";
  }, []);

  return (
    <>
      <TopBanner content={"Refund Policy"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Refund Policy</h2>
          <p>
            This Refund Policy outlines the conditions under which refund
            requests may be considered for services provided through the
            Wealthies platform operated by Shreeman Assure Services Pvt Ltd.
          </p>
          <p>
            By purchasing services or registering for services on the Wealthies
            platform, users agree to the terms described in this policy.
          </p>
          <h5>1. Nature of Services</h5>
          <p>
            Wealthies provides digital platform services including marketing
            support, advisor onboarding, and customer inquiry facilitation for
            licensed insurance professionals.
          </p>
          <p>
            Due to the nature of digital services and platform-based
            opportunities, refund eligibility is limited and subject to the
            conditions described below.
          </p>
          <h5>2. Refund Eligibility</h5>
          <h6>Within 24 Hours</h6>
          <p>
            If a refund request is submitted within 24 hours of payment, up to
            80% of the base payment amount may be eligible for refund.
            Applicable administrative or operational deductions may apply.
          </p>
          <h6>Between 24 Hours and 48 Hours</h6>
          <p>
            If a refund request is submitted after 24 hours but within 48 hours
            of payment, up to 50% of the base payment amount may be eligible for
            refund.
          </p>
          <h5>After 48 Hours</h5>
          <p>
            Refund requests submitted after 48 hours of payment will not be
            eligible for any refund.
          </p>
          <h5>3. GST and Taxes</h5>
          <p>
            Any GST or applicable taxes charged on the invoice are
            non-refundable under all circumstances, as taxes are collected and
            remitted in accordance with applicable tax regulations.
          </p>
          <p>
            Refunds, if applicable, will only be calculated on the base service
            amount excluding GST or other applicable taxes.
          </p>
          <h5>4. Service Initiation</h5>
          <p>
            If services such as advisor onboarding, lead allocation, campaign
            activation, or other operational processes have already been
            initiated, refund eligibility may be restricted or declined.
          </p>
          <h5>5. Non-Refundable Situations</h5>
          <ul>
            <li>services already initiated or delivered</li>
            <li>incorrect or incomplete information provided by the user</li>
            <li>violation of platform policies or misuse of services</li>
            <li>failure to respond to onboarding or verification requests</li>
          </ul>
          <h5>6. Refund Requests</h5>
          <p>
            Users requesting refunds must submit a request to the Wealthies
            support team with relevant payment details and reason for the
            request.
          </p>
          <p>
            Requests may be submitted via the official support contact details
            available on the Wealthies website.
          </p>
          <h5>7. Policy Updates</h5>
          <p>
            Wealthies reserves the right to modify or update this Refund Policy
            at any time to reflect operational or regulatory requirements.
          </p>
          <h2>Renewal Payments</h2>
          <p>Payments made towards renewal of services are non-refundable.</p>
          By proceeding with a renewal payment, the user acknowledges that they
          are aware of the nature of services provided on the platform and are
          choosing to continue based on their own discretion and experience.
          Accordingly, no refund requests will be accepted for renewal payments
          under any circumstances. Refund Queries For any refund-related
          queries, users may contact
          <Text>
            <a href="mailto:payments@wealthies.in">
              Email: payments@wealthies.in
            </a>
          </Text>
        </div>
      </ContentWrapper>
    </>
  );
};

export default RefundPolicy;
